import { toLocaleCurrencyString } from '@/lib/toLocaleCurrencyString';
import { Price, RecurringInterval } from '@/types';
import { ArrowTrendingUpIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

type Props = {
  price?: Price;
  discountPercentage?: number;
  recurringInterval: RecurringInterval;
};

export const PriceDisplay = ({
  price,
  discountPercentage,
  recurringInterval,
}: Props) => {
  const { t } = useTranslation();

  if (!price) return null;

  const renderDescription = () => {
    if (!discountPercentage) return null;

    if (recurringInterval === 'year') {
      return (
        <span className="text-green-600">
          {t('月額{{percentage}}%お得', {
            percentage: discountPercentage,
          })}
        </span>
      );
    }

    return (
      <span className="flex items-center gap-1 text-gray-600">
        <ArrowTrendingUpIcon className="size-4" />
        {t('年払いで{{percentage}}%お得', {
          percentage: discountPercentage,
        })}
      </span>
    );
  };

  return (
    <div className="mb-6 rounded-xl bg-white px-8">
      <div className="flex min-h-20 flex-col items-center justify-center">
        <div className="flex items-baseline justify-center">
          <span className="text-4xl font-bold text-gray-900">
            {toLocaleCurrencyString(price.displayAmountMonthly, price.currency)}
          </span>
          <span className="ml-2 text-lg text-gray-600">/ {t('月')}</span>
        </div>
        <div className="mt-2 text-sm font-medium">{renderDescription()}</div>
      </div>
    </div>
  );
};
